import service from '@services';
import { User } from '@datamodel';
const PREFIX = '/profile';

export const get = async () => {
    const response = await service.get(`${PREFIX}/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            profile: User.parse(response.response),
        }
    }
    throw service.error(response);
}

// 'id',
//     'slug',
//     'name',
//     'address',
//     'photo_url',
//     'logo_url',
//     'primary_color',
//     'minimum_order_amount',